import React from 'react';
import {
  GridRow,
  Cell,
  CellIcon,
  Label,
  StyledInput,
} from './AllocationRow.styles';
import { IAllocationListItem, IAllocation } from '../types';
import { ApIcon } from '@alixpartners/ui-components';
import debounce from 'lodash/debounce';

interface IProps {
  data: IAllocationListItem;
  onChange(application: IAllocation): void;
  isInvalid?: boolean;
  search?: string;
}

interface IState {
  value: number;
}

export class AllocationRow extends React.Component<IProps, IState> {
  state = {
    value: this.props.data.percentage || 0,
  };

  changeAllocation = debounce((allocation: IAllocation) => {
    const { onChange } = this.props;

    onChange(allocation);
  }, 300);

  componentDidUpdate(prevProps: IProps) {
    const { data } = this.props;

    if (data.percentage !== prevProps.data.percentage) {
      this.setState({ value: data.percentage || 0 });
    }
  }

  handleInputChange = (item: IAllocationListItem) => (value: string) => {
    let number = Math.floor(Number(value));

    if (number > 100) {
      number = 100;
    }

    if (number < 0) {
      number = 0;
    }

    this.setState({ value: number });
    this.changeAllocation({
      id: item.id,
      name: item.name,
      percentage: number,
    });
  };

  getHighlightedName = (name: string) => {
    const { search } = this.props;

    if (!search) {
      return name;
    }

    const index = name.toLowerCase().indexOf(search.toLowerCase());
    const before = name.slice(0, index);
    const searchValue = name.slice(index, index + search.length);
    const after = name.slice(index + search.length, name.length);

    return (
      <span>
        {before}
        <b>{searchValue}</b>
        {after}
      </span>
    );
  };

  render() {
    const { data, isInvalid } = this.props;
    const { value } = this.state;
    const { name, flag } = data;
    const showFlag = flag !== undefined;

    return (
      <GridRow isInvalid={isInvalid && !!value} isHighlighted={!!value}>
        <Cell>
          <Label title={name}>{this.getHighlightedName(name)}</Label>
        </Cell>
        <Cell>
          <StyledInput
            value={value ? String(value) : ''}
            onChange={this.handleInputChange(data)}
            placeholder="-"
            symbol="%"
            {...{ type: 'number' }}
          />
        </Cell>
        {showFlag && (
          <CellIcon>{flag && <ApIcon iconName="flag_outlined" />}</CellIcon>
        )}
      </GridRow>
    );
  }
}
